import { render } from "./CheckoutWhiteChangeTheirLife.vue?vue&type=template&id=312cc06e"
import script from "./CheckoutWhiteChangeTheirLife.vue?vue&type=script&lang=js"
export * from "./CheckoutWhiteChangeTheirLife.vue?vue&type=script&lang=js"

import "./CheckoutWhiteChangeTheirLife.vue?vue&type=style&index=0&id=312cc06e&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__